// extracted by mini-css-extract-plugin
export var copyableField = "_lg-4";
export var customerBadge = "_lg-0";
export var customerInfoTitle = "_lg-2";
export var details = "_lg-1";
export var dropdownContainer = "_lg-5";
export var dropdownImage = "_lg-6";
export var editAssigneeForm = "_lg-a";
export var editButton = "_lg-3";
export var email = "_lg-7";
export var hidden = "_lg-d";
export var input = "_lg-8";
export var saveButton = "_lg-b";
export var shopifyIcon = "_lg-c";
export var suggestionBadge = "_lg-e";
export var suggestionText = "_lg-f";
export var username = "_lg-9";